import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

const PrintSetlists = ({ setlist1, setlist2, setlist3 }) => {
    const printRef = useRef();

    const handleDownloadPDF = () => {
        const element = printRef.current;
        const opt = {
            margin: 0.5,
            filename: "setlists.pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
        };
        html2pdf().set(opt).from(element).save();
    };
    //object?.property means:If object exists (not null or undefined), then get property.
    //If object is null or undefined, return undefined instead of throwing an error.
    const allEmpty = !setlist1?.length && !setlist2?.length && !setlist3?.length;

    return (
        <div>
            {/* PDF Button */}
            {!allEmpty && (
                <button onClick={handleDownloadPDF} style={{ marginTop: "20px" }}>
                    Download PDF
                </button>
            )}
            {allEmpty ? (
                <p>No setlists available.</p>
            ) : (
                <div ref={printRef} className="print-container">
                    {[setlist1, setlist2, setlist3].map((setlist, index) => (
                        <div key={index} className="setlist-column">
                            <h3>Set {index + 1}</h3>
                            <ol>
                                {(Array.isArray(setlist) ? setlist : []).map((song) => (
                                    <li
                                        key={song.id}
                                        style={{ display: "flex", alignItems: "center" }}
                                    >
                                        <span>{song.songTitle}</span>
                                        {song.tracks && (
                                            <input
                                                type="checkbox"
                                                checked
                                                readOnly
                                                style={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </div>
                    ))}
                </div>
            )}

           

            <style>
                {`
          .print-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background:#fff;
            color:#000;
          }
          .print-container li {
            margin-bottom: 16px;
          }
          .setlist-column {
            flex: 1;
            padding: 0.2in;
            box-sizing: border-box;
          }
        `}
            </style>
        </div>
    );
};

export default PrintSetlists;
